import produce from 'immer'
import { combineReducers } from 'redux'
import { fetchRulesAsync } from 'shared/store/actions/rules'
import { Rule } from 'shared/typings/rules/Rule'

import { AnyRootAction, createReducer } from 'typesafe-actions'

const byId = createReducer<Record<number, Rule>, AnyRootAction>({}).handleAction(
  [fetchRulesAsync.success],
  (state, action: { payload: Rule[] }) => {
    return produce(state, (draft) => {
      action.payload.forEach((rule) => {
        draft[rule.id] = rule
      })
    })
  }
)

export default combineReducers({
  byId,
})
